export const WorkflowOptionFragment = gql`
  fragment WorkflowOptionFragment on Workflow {
    id
    completedAt
    createdAt
    status
    workflowTemplate {
      id
      name
    }
  }
`
export const WorkflowFragment = gql`
  fragment WorkflowFragment on Workflow {
    id
    recordTaskGroups {
      ...WorkflowRecordTaskGroupFragment
    }
    recordTaskInspectionGroups {
      id
    }
    workflowTemplate {
      id
    }
    generatedDocuments {
      id
    }
  }
`
export const WorkflowRecordTaskGroupFragment = gql`
  fragment WorkflowRecordTaskGroupFragment on RecordTaskGroup {
    automaticTaskExplanation
    completedAt
    hasAutomaticTasks
    id
    isLocked
    name
    ordinal
    record {
      id
      applicantUser {
        ...UserDataFragment
      }
      status {
        ...RecordTypeStatusFragment
      }
    }
    recordTaskTemplateGroup {
      attachGeneratedDocumentsByDefault
      changeToStatus {
        ...RecordTypeStatusFragment
      }
      defaultRenewalWorkflowTemplateId
      defaultEmailTemplate {
        id
      }
      defaultEmailApplicant
      defaultEmailOwner
      defaultRecipientUsers {
        ...UserDataFragment
      }
      defaultSearchForNearbyPropertiesDistanceUnit
      defaultSearchForNearbyPropertiesDistanceValue
      defaultSearchForNearbyPropertiesEntityLayer {
        id
      }
      id
      identifier
      notificationScheduledEventTemplates {
        id
      }
      requestedRecordConfigs {
        ...RecordTaskTemplateGroupRequestedRecordFragment
      }
      shouldRenewAsNewRecord
      workflowScheduledEventTemplates {
        id
        beginWorkflowTemplateId
        dateTemplate {
          ...DateTemplateFragment
        }
      }
    }
    recordTasks {
      ...WorkflowRecordTaskFragment
    }
    startedAt
    status
    type
  }
`
export const WorkflowRecordTaskFragment = gql`
  fragment WorkflowRecordTaskFragment on RecordTask {
    id
    uuid
    name
    dueDate
    updatedAt
    startedAt
    completedAt
    completedAutomatically
    status
    type
    isWaitingOnApplicant
    applicationReviewComment
    applicationReviewResult
    applicationReviewedAt
    applicationReviewCanceledAt
    applicationReviewDeclinedAt
    planReviewRevisionRequestComment
    isCustomTaskAndInProgress
    plansSetReview {
      id
      totalComments
      recordPlansSetId
      result {
        id
        name
        isPassing
      }
    }
    checklistItems {
      ...RecordTaskChecklistItemFragment
    }
    completedByUser {
      ...UserDataFragment
    }
    createdByUser {
      ...UserDataFragment
    }
    createdRecord {
      id
      uuid
    }
    fieldGroup {
      ...FieldGroupFragment
    }
    completedByUser {
      ...UserDataFragment
    }
    ownerUser {
      ...UserDataFragment
    }
    recordTaskPayment {
      totalWhenInvoiceRequestedCents
      status
    }
    recordTaskTemplate {
      name
      addFilesToPlanReview
      taskTemplate {
        id
        identifier
        fieldGroup {
          ...FieldGroupFragment
        }
      }
    }
    requestedRecordTemplate {
      ...RecordTemplateOptionFragment
    }
    revisionOfPlansSet {
      id
    }
    recordTaskGroup {
      id
      record {
        id
        uuid
      }
    }
  }
`
